import RenderChange from './render-change';
export default RenderChange;
